
        var result = require("!!../../../../node_modules/css-loader/index.js!./cases-management.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cases-management/cases-management.component.css
// module id = 597
// module chunks = 0